import React from 'react';
import IconType from './iconType';

export default function BlocksFtux({ color = '#9D9D9D', height = 68, width = 86 }: IconType) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 86 68" fill="none">
      <rect
        x="1.48837"
        y="0.988372"
        width="83.0233"
        height="17.7907"
        rx="2.96512"
        stroke={color}
        strokeWidth="1.97674"
      />
      <rect
        x="1.48837"
        y="24.7071"
        width="83.0233"
        height="17.7907"
        rx="2.96512"
        stroke={color}
        strokeWidth="1.97674"
      />
      <rect
        x="1.48837"
        y="48.4337"
        width="83.0233"
        height="17.7907"
        rx="2.96512"
        stroke={color}
        strokeWidth="1.97674"
      />
    </svg>
  );
}
